import React, { useEffect, useState, useRef } from "react";
import "../styles/CompRegInput.css";
import Uploadbutton from "../icons/BusinessHub/Uploadbutton";
import Utils from "../utils/Utils.js";

function CompRegInput({ onDataChange }) {
  const ownerIDPassportRef = useRef(null);
  const policeCertificateRef = useRef(null);
  const legalProofRef = useRef(null);
  const [ownerIDPassport, setOwnerIDPassport] = useState({ name: "" });
  const [policeCertificate, setPoliceCertificate] = useState({ name: "" });
  const [legalProof, setLegalProof] = useState({ name: "" });
  const [companyName, setCompanyName] = useState("");
  const [taxNumber, setTaxNumber] = useState("");

  useEffect(() => {
    onDataChange({
      companyName,
      taxNumber,
      documents: {
        ownerIDPassport,
        policeCertificate,
        legalProof,
      },
    });
  }, [companyName, taxNumber, ownerIDPassport, policeCertificate, legalProof]);

  const handleFileChange = async (e, setter) => {
    const file = e.target.files[0];
    if (!file) return;

    if (!file.type.startsWith("image/")) {
      alert("Only image files are allowed");
      return;
    }

    if (file.size > 50 * 1024 * 1024) {
      alert("Max file size is 50MB");
      return;
    }

    try {
      const fileData = await Utils.processImageFile(file, 8);
      setter(fileData);
    } catch (err) {
      alert(err.message);
    }
  };
  return (
    <div className="comp-reg-window-container-div">
      <div className="comp-reg-info-input">
        <div className="comp-reg-info-input-header">Company Information</div>
        <div className="comp-reg-info-input-body">
          <div className="comp-reg-info-data-input">
            <div className="comp-reg-info-data-input-cont">
              Company Name <div className="required">*</div>
            </div>
            <div className="comp-reg-info-input-data">
              <input
                className="comp-reg-info-input-data-tag"
                value={companyName}
                onChange={(e) => setCompanyName(e.target.value)}
              ></input>
            </div>
          </div>
          <div className="comp-reg-info-data-input">
            <div className="comp-reg-info-data-input-cont">
              TAX Number <div className="required">*</div>
            </div>
            <div className="comp-reg-info-input-data">
              <input
                className="comp-reg-info-input-data-tag"
                type="text"
                inputMode="numeric"
                pattern="[0-9]*"
                value={taxNumber}
                onChange={(e) => {
                  const onlyNumbers = e.target.value.replace(/\D/g, "");
                  setTaxNumber(onlyNumbers);
                }}
              ></input>
            </div>
          </div>
        </div>
        <div className="comp-reg-info-input-body-doc">
          <div className="comp-reg-info-input-body-doc-title">
            Required Documents
          </div>

          {/**********************************************************/}
          <div className="comp-reg-info-input-body-doc-data">
            {/*Owner ID/ Passport*/}
            <div className="ssssssssssssss">
              <div className="comp-reg-info-data-input-cont">
                Owner ID/ Passport <div className="required">*</div>
              </div>
              <div
                className="verification-documents-input-container"
                onClick={() => ownerIDPassportRef.current?.click()}
              >
                <div className="verification-documents-icon">
                  <Uploadbutton />
                </div>
                <input
                  type="file"
                  ref={ownerIDPassportRef}
                  style={{ display: "none" }}
                  onChange={async (e) => {
                    const file = e.target.files[0];
                    if (!file) return;

                    try {
                      const fileData = await Utils.processImageFile(file);
                      setOwnerIDPassport(fileData);
                    } catch (err) {
                      alert(err.message);
                    }
                  }}
                />
                <input
                  placeholder="ID or Passport Image"
                  className="verification-documents-input"
                  value={ownerIDPassport.name}
                  readOnly
                />
              </div>
            </div>

            {/*Police Clearance Certificate*/}
            <div className="ssssssssssssss">
              <div className="comp-reg-info-data-input-cont">
                Police Clearance Certificate <div className="required">*</div>
              </div>
              <div
                className="verification-documents-input-container"
                onClick={() => policeCertificateRef.current?.click()}
              >
                <div className="verification-documents-icon">
                  <Uploadbutton />
                </div>
                <input
                  type="file"
                  ref={policeCertificateRef}
                  style={{ display: "none" }}
                  onChange={async (e) => {
                    const file = e.target.files[0];
                    if (!file) return;

                    if (!file.type.startsWith("image/")) {
                      alert("Only image files are allowed");
                      return;
                    }

                    if (file.size > 50 * 1024 * 1024) {
                      alert("Max file size is 50MB");
                      return;
                    }
                    try {
                      const fileData = await Utils.processImageFile(file, 8);
                      setPoliceCertificate(fileData);
                    } catch (err) {
                      alert(err.message);
                    }
                  }}
                />
                <input
                  placeholder="Certificate Image"
                  className="verification-documents-input"
                  value={policeCertificate.name}
                  readOnly
                />
              </div>
            </div>
          </div>

          <div className="comp-reg-info-input-body-doc-data-row">
            {/*Proof of Legal Entity*/}
            <div className="comp-reg-info-data-input-cont">
              Proof of Legal Entity <div className="required">*</div>
            </div>
            <div
              className="verification-documents-input-container"
              onClick={() => legalProofRef.current?.click()}
            >
              <div className="verification-documents-icon">
                <Uploadbutton />
              </div>
              <input
                type="file"
                ref={legalProofRef}
                style={{ display: "none" }}
                onChange={async (e) => {
                  const file = e.target.files[0];
                  if (!file) return;

                  if (!file.type.startsWith("image/")) {
                    alert("Only image files are allowed");
                    return;
                  }

                  if (file.size > 50 * 1024 * 1024) {
                    alert("Max file size is 50MB");
                    return;
                  }
                  try {
                    const fileData = await Utils.processImageFile(file, 8);
                    setLegalProof(fileData);
                  } catch (err) {
                    alert(err.message);
                  }
                }}
              />
              <input
                placeholder="Proof Image"
                className="verification-documents-input"
                value={legalProof.name}
                readOnly
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CompRegInput;
